module.exports = __webpack_public_path__ + "static/img/8.080ef06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/8.png
// module id = R5sQ
// module chunks = 0